import React from 'react';
import { motion } from 'framer-motion';
import { bonos } from '../data/content';
export function Bonos() {
  return <section aria-labelledby="bonos-titulo" className="w-full bg-cream py-14 sm:py-20" data-id="element-20" data-mp="2hdmmpkxwsw3y">
      <div className="mx-auto max-w-6xl px-5" data-id="element-21" data-mp="2ldwpypubh8f4">
        <div className="mx-auto max-w-2xl text-center" data-id="element-22" data-mp="2lc26zh2lvqdo">
          <h2 id="bonos-titulo" className="font-display text-3xl font-extrabold text-navy text-balance sm:text-4xl" data-id="element-23" data-mp="2q5wxp4gmp5m9">
            🎁 6 Bonos estratégicos — siempre incluidos, nunca optativos
          </h2>
          <p className="mt-4 text-base leading-relaxed text-navy/75 sm:text-lg" data-id="element-24" data-mp="3055nrm8di03c">
            Porque tener el material no alcanza. También necesitás saber cómo empezar,
            cómo organizarte y cómo hacer que el proceso sea sostenible semana a semana.
          </p>
        </div>

        <ul className="mt-10 grid gap-4 md:grid-cols-2" data-id="element-25" data-mp="1apxu86hyhxsc">
          {bonos.map((bono, index) => <motion.li key={bono.number} initial={{
          opacity: 0,
          y: 18
        }} whileInView={{
          opacity: 1,
          y: 0
        }} viewport={{
          once: true,
          margin: '-60px'
        }} transition={{
          duration: 0.4,
          delay: index * 0.05,
          ease: 'easeOut'
        }} className="flex gap-4 rounded-2xl border border-navy/10 bg-white p-5 shadow-card" data-id="element-26" data-mp="1epzz0oizn7bu" data-mpi={index}>
              <span className="flex h-10 w-10 shrink-0 items-center justify-center rounded-xl bg-celeste-light font-display text-sm font-extrabold text-navy" aria-hidden="true" data-id="element-27" data-mp="2zgy0dwvhoo3f">
                {bono.number}
              </span>
              <div className="flex flex-1 flex-col" data-id="element-28" data-mp="3n3eah538g1fp">
                <h3 className="font-display text-base font-extrabold leading-tight text-navy sm:text-lg" data-id="element-29" data-mp="3i5mikb2l8fbi">
                  🎁 Bono {Number(bono.number)} — {bono.title}
                </h3>
                <p className="mt-2 text-sm leading-relaxed text-navy/75" data-id="element-30" data-mp="2bn66cz85ki1x">
                  {bono.description}
                </p>
                <p className="mt-auto flex flex-wrap items-center gap-2 pt-4 text-sm font-bold" data-id="element-31" data-mp="yqgxfcm78y77">
                  <span className="text-navy/45" data-id="element-32" data-mp="12t3tjppwl5a7">Valor: </span>
                  <span className="text-navy/45 line-through" data-id="element-33" data-mp="12q9d09a0g4m2">{bono.price}</span>
                  <span className="text-navy/45" aria-hidden="true" data-id="element-34" data-mp="osksj2juuzhj">
                    →
                  </span>
                  <span className="rounded-full bg-green-600 px-2.5 py-0.5 font-display text-xs font-extrabold uppercase tracking-wide text-white" data-id="element-35" data-mp="ttqln1hfgorl">
                    Gratis con tu MegaPack
                  </span>
                </p>
              </div>
            </motion.li>)}
        </ul>

        <div className="mx-auto mt-9 max-w-xl rounded-2xl bg-navy px-6 py-5 text-center" data-id="element-36" data-mp="60i7lf06kx1h">
          <p className="font-display text-lg font-extrabold text-white sm:text-xl" data-id="element-37" data-mp="azbnfe2xx04t">
            Valor total de bonos:{' '}
            <span className="line-through opacity-60" data-id="element-38" data-mp="12ytcf3hgk9j">$53.000</span> →{' '}
            <span className="text-gold" data-id="element-39" data-mp="15cjc9jb36a8">$0</span>
          </p>
          <p className="mt-1 text-sm font-semibold text-celeste-light" data-id="element-40" data-mp="3dnm1o1o8586e">
            Incluidos con tu MegaPack. Siempre.
          </p>
        </div>
      </div>
    </section>;
}